import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { createRequestOption } from 'app/shared/util/request-util';
import { IPharmacyLocationsRx } from 'app/shared/model/pharmacy-locations-rx.model';
import { Observable } from 'rxjs';
import AppConfigService from 'app/core/app-config.service';

type EntityResponseType = HttpResponse<IPharmacyLocationsRx>;
type EntityArrayResponseType = HttpResponse<IPharmacyLocationsRx[]>;

@Injectable({ providedIn: 'root' })
export default class PharmacyLocationsRxService {
  public resourceUrl = `${AppConfigService.envConfig.fssServicesBaseUrl}api/pharmacy-locations`;

  constructor(protected http: HttpClient) {}

  find(id: number): Observable<EntityResponseType> {
    return this.http.get<IPharmacyLocationsRx>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.http.get<IPharmacyLocationsRx[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  getPharmacies() {
    return this.http.get(`${AppConfigService.envConfig.fssServicesBaseUrl}api/rx/pharmacy`, {
      headers: new HttpHeaders().set('Accept', '*/*')
    });
  }

  getPharmacyImage(id, imageName) {
    return this.http.get(`${AppConfigService.envConfig.fssServicesBaseUrl}api/pharmacy/downloadimage/${id}/${imageName}`, { responseType: 'blob' });
  }
}
